import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import classnames from 'classnames';
import Icon from '../../icons/Icon';

const iconRotation = keyframes`
	// from {
	// 	transform: translate(-50%,-50%) rotate(0deg);
	// }
	to {
		transform: rotate(360deg);
	}
`;

const StyledIcon = styled(Icon)`
  transform: rotate(0deg);
  cursor: pointer;
  
  &.isLoading {
    animation-name: ${iconRotation};
    animation-duration: .75s;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;

    cursor: default;
  }
`;

class RefreshButton extends Component {
  state = {
    rotating: false,
  };

  onAnimationEnd = () => {
    this.setState({
      rotating: false,
    });
  };

  onClick = () => {
    if(this.state.rotating) return;
    this.setState({
      rotating: true,
    });
    this.props.onClick();
  };

  render() {
    const iconClassName = classnames({
      isLoading: this.state.rotating,
    });

    return (
      <a
        onClick={this.onClick}
        onAnimationEnd={this.onAnimationEnd}
      >
        <StyledIcon
          className={iconClassName}
          icon="#refresh"
        />
      </a>
    );
  }
};

export default RefreshButton;


// WEBPACK FOOTER //
// ./src/ui/button/RefreshButton.js